import { injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { useWindowResize } from '../../../utils/commonFunctions'
import { StyledNavigation } from './StyledNavigation'
import IconButton from '../../icon-button/IconButton'
import { PhotosApi } from '../../../utils/api/photosApi'
import React from 'react'

const StoreNavigation = (props: any) => {
    const { storeName, storeCode, isModalHeader, shouldFullScreen, isFullScreen, photo, banner, photoList, isApp, intl } = props
    const isMobileNow = useWindowResize()

    return (
        <StyledNavigation style={{ width: '100%' }}>
            <Link
                className={
                    'navigation-link' +
                    (isMobileNow || isModalHeader ? ' mobile' : '')
                }
                to="/home">
                {!isModalHeader && <i className="pi pi-angle-left"></i>}
                <div className="p-d-inline name-container" style={ { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' } }>
                    {' '}
                    <div className="store-name"> {storeName}</div>
                </div>
            </Link>
        </StyledNavigation>
    )
}

export default injectIntl(StoreNavigation)
